import { createSessionFromToken } from "@shared/lib/auth/session-auth";
import { tokenStorage } from "../settings/tokenStorage";
import { WALTER_HOST } from "../env-vars";

const OAUTH_PROVIDER = "walter";

/**
 * Authenticates the chat session by exchanging the current OAuth token for a session cookie.
 * This enables the chat iframe to make authenticated requests to Walter.
 *
 * @throws Error if no access token is available or session creation fails
 */
export async function authenticateChatSession(): Promise<void> {
  const token = await tokenStorage.get(OAUTH_PROVIDER);

  if (!token?.accessToken) {
    throw new Error("No access token available. Please log in first.");
  }

  // Use shared library to create session from token
  await createSessionFromToken(token.accessToken, WALTER_HOST);
}

/**
 * Checks if user is authenticated (has a valid token)
 */
export async function isAuthenticated(): Promise<boolean> {
  const token = await tokenStorage.get(OAUTH_PROVIDER);
  return !!token?.accessToken;
}
